import axios from "axios";
/* eslint-disable */
let token =
  localStorage.getItem("token") !== null ? localStorage.getItem("token") : "";

const setToken = async (data) => {
  const url = `http://164.90.236.174:1988/koinot/auth/login`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.post(url, data, headers);
    token = res.data.objectKoinot.accessToken;
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

const getData = async (type, id) => {
  const url = `http://164.90.236.174:1988/koinot/news/${type}/${id}`;
  try {
    const res = await axios.get(
      url,

      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

const setData = async (body, path, callback, model) => {
  const url = `http://164.90.236.174:1988/koinot/news`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.post(url, body, headers);

    if (path == "news") {
      callback("d-block", res.data.object);
      model(`Post ${res.data.object.id} muvaffaqiyatli joylandi`, res.data);
    } else {
      callback("d-block", "child");
      model("Post tarkibi muvaffaqiyatli joylandi");
    }
    return res;
  } catch (error) {
    callback("d-block");
    model(
      "Post joylashda xatolik! Maydonlarni to'liq to'ldirmagan bo'lishingiz mumkin"
    );
    console.error(error);
    return { error: true, error };
  }
};
const setChildData = async (body, success, successCallback) => {
  const url = `http://164.90.236.174:1988/koinot/newsChild`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.post(url, body, headers);
    success(true);
    successCallback(`Post o'zgartirildi`, "s");
    return res;
  } catch (error) {
    successCallback(`Logout qilib qayta kiring`, "e");
    console.error(error);
    return { error: true, error };
  }
};

const getTag = async () => {
  const url = `http://164.90.236.174:1988/koinot/tag`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

const getCategory = async () => {
  const url = `http://164.90.236.174:1988/koinot/category`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};
const setCategory = async (body) => {
  const url = `http://164.90.236.174:1988/koinot/category`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.post(url, body, headers);
    alert("Kategoriya qo'shildi");
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};
const setImage = async (body) => {
  const url = `http://164.90.236.174:1988/koinot/attachment/uploadPhotoFileList/NEWS?requestMethod=POST`;
  const config = {
    headers: {
      "Content-type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(url, body, config);
    return res;
  } catch (error) {
    console.error(error);
    alert("Faqat rasm yuklashga ruxsat bor");
    return { error: true, error };
  }
};

const getDataWith__ID = async (newsId) => {
  const url = `http://164.90.236.174:1988/koinot/news/newsByIdForAdmin/${newsId}`;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(url, config);
    return res;
  } catch (error) {
    return error.response;
  }
};

const getDataWith_catId = async (catID) => {
  const url = `http://164.90.236.174:1988/koinot/news/byCategoryId/${catID}`;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(url, config);
    return res;
  } catch (error) {
    return error.response;
  }
};

const getImage = async (id) => {
  const url = `http://164.90.236.174:1988/koinot/attachment/byteFile/${id}`;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(url, config);
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

const getFeedback = async () => {
  const url = `http://164.90.236.174:1988/koinot/feedback?active=true`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};
const getReadFeedback = async () => {
  const url = `http://164.90.236.174:1988/koinot/feedback?active=false`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

// /koinot/feedback/changeActive/{id}

const setFeedBack = async (id) => {
  const url = `http://164.90.236.174:1988/koinot/feedback/changeActive/${id}?active=false`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.put(url, { id: id, active: false }, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

// get all posts
const getAllPosts = async (page) => {
  const url = `http://164.90.236.174:1988/koinot/news/list?${page}`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

// search
const SearchPosts = async (body) => {
  const url = `http://164.90.236.174:1988/koinot/news/search?search=${body}`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.get(url, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

const ChangeActive = async (body, active) => {
  const url = `http://164.90.236.174:1988/koinot/news/changeActive/${body}?active=${active}`;
  const headers = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const res = await axios.post(url, body, headers);
    return res;
  } catch (error) {
    console.error(error);
    return { error: true, error };
  }
};

export {
  setData,
  getData,
  getTag,
  getCategory,
  setImage,
  setCategory,
  getDataWith__ID,
  getDataWith_catId,
  setChildData,
  getImage,
  getFeedback,
  setFeedBack,
  getReadFeedback,
  getAllPosts,
  setToken,
  SearchPosts,
  ChangeActive,
  token,
};



// WEBPACK FOOTER //
// ./src/API/index.js